import React from 'react';
import i18n from "i18next";
import { Input } from 'antd';

const InputSearch = Input.Search;

class Search extends React.Component {
  
  state = {
    inputValue: '',
  }
    
  executeSearch(value){
    const {onSearch} = this.props;
    if (onSearch) onSearch(value);
  }

  render() {
    const { tags, inputVisible, inputValue } = this.state;
    return (
        <InputSearch placeholder={i18n.t('components.search.placeholder')} 
          enterButton={i18n.t('components.search.enterButton')} size="large"
          onSearch={value => this.executeSearch(value)}
        />
    );
  }
}
  
export default Search